import React from 'react';

import { TextField } from '@material-ui/core';
import useStyles from './styles';

const NumericAnswer = ({ editableAnswer, setEditableAnswer }) => {
  const classes = useStyles();

  const handleOnChange = (e) => {
    const value = e.target.value.replace(/,/g, '.');
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setEditableAnswer(value);
    }
  };

  return (
    <div className={classes.content}>
      <TextField
        value={editableAnswer}
        type="text"
        variant="outlined"
        className={classes.textField}
        onChange={(e) => handleOnChange(e)}
        inputProps={{
          inputMode: 'decimal',
        }}
      >
      </TextField>
    </div>
  );
};

export default NumericAnswer;
